import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getUserGroup = async (queryString) => {
  try {
    const url = `${apiUrl}/usergroups${queryString ? `?${queryString}` : ""}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getUserGroupforEdit = async () => {
  try {
    const url = `${apiUrl}/usergroups`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const addUserGroup = async (req) => {
  try {
    const url = `${apiUrl}/usergroups`;
    const { data } = await httpService.post(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};

const updateUserGroup = async (id, req) => {
  try {
    const url = `${apiUrl}/usergroups/${id}`;
    const { data } = await httpService.put(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};

const deleteUserGroup = async (id) => {
  try {
    const url = `${apiUrl}/usergroups/${id}`;
    const { data } = await httpService.delete(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getTagMarkup = async () => {
  try {
    const url = `${apiUrl}/usergroups/tagmarkup`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getCommissionMarkup = async () => {
  try {
    const url = `${apiUrl}/usergroups/commissionmarkup`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getUsergroupById = async (id) => {
  try {
    const url = `${apiUrl}/usergroups/${id ? id : ""}`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const addRailCommission = async (value) => {
  try {
    const url = `${apiUrl}/usergroups/taggedrailcommission`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const updateRailCommission = async (value) => {
  try {
    const url = `${apiUrl}/usergroups/updaterailcommission`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const getMarkupCommById = async (id) => {
  try {
    const url = `${apiUrl}/commission/get-admin-commission/${id}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const addMarkupCommission = async (value) => {
  try {
    const url = `${apiUrl}/commission/admin-markup-commission`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const getAirlinesMarkupCommById = async (id) => {
  try {
    const url = `${apiUrl}/supplier-master/getSupplierWiseCommission/${id}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const addAirlinesMarkupCommission = async (value) => {
  try {
    const url = `${apiUrl}/supplier-master/add-supplierwise-user-markup`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
export {
  getAirlinesMarkupCommById,
  addAirlinesMarkupCommission,
  getUserGroup,
  getUserGroupforEdit,
  addUserGroup,
  updateUserGroup,
  deleteUserGroup,
  getTagMarkup,
  getUsergroupById,
  getCommissionMarkup,
  addRailCommission,
  updateRailCommission,
  getMarkupCommById,
  addMarkupCommission,
};
